



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from '@/models/User';
import { BFormInput, BModal, BButton } from 'bootstrap-vue';
import { mapGetters } from 'vuex';

@Component({
    name: 'ModalUserConfig',
    components: {
        'b-modal': BModal,
        'b-button': BButton,
        'b-form-input': BFormInput,
    },
    computed: mapGetters({
        account: 'account/account',
        isOwner: 'organisation/organisation',
    }),
})
export default class ModalAccountRemove extends Vue {
    error = '';
    check = '';
    updating = false;
    account!: User;

    async deleteAccount() {
        this.updating = true;

        try {
            const r = await this.$store.dispatch('users/delete', this.account);

            if (r.response) {
                if (r.response.status === 403) {
                    throw new Error(
                        'You are required to remove all other users in your organisation before removal is allowed.',
                    );
                }

                if (r.response.status === 404) {
                    throw new Error(`Account not found (${r.response.status})`);
                }

                if (r.response.status === 500) {
                    throw new Error(`An error occured (${r.response.status})`);
                }
            }

            this.$router.push('/logout');
        } catch (e) {
            this.error = e;
        }
    }
}
